export const HEADER_HEIGHT = 56;
export const SIDEBAR_WIDTH = {
  FULL: 280,
  MINI: 54,
};
